import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CollectionsIcon from '@material-ui/icons/Collections';
import ListIcon from '@material-ui/icons/List';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
    display: 'inline-block',
    width: '72px',
    height: '40px',
    '& > input': {
      opacity: 0,
      width: 0,
      height: 0,
    },
  },

  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.primary.main,
    WebkitTransition: '.4s',
    transition: '.4s',
  },
  button: {
    position: 'absolute',
    zIndex: 1,
    height: '34px',
    width: '34px',
    left: '4px',
    bottom: '3px',
    backgroundColor: 'white',
    WebkitTransition: '.4s',
    transition: '.4s',
    borderRadius: '50%',
  },
  sliderChecked: {},
  buttonChecked: {
    WebkitTransform: 'translateX(28px)',
    msTransform: 'translateX(28px)',
    transform: 'translateX(28px)',
  },
  round: {
    borderRadius: '34px',
    '&:before': {
      borderRadius: '50%',
    },
  },
  icon: {
    position: 'relative',
    zIndex: 2,
    marginLeft: '4px',
    marginTop: '11px',
    fontSize: '1.4em',
  },
  thumbnailIcon: {
    color: theme.palette.primary.main,
  },
  listIcon: {
    color: theme.palette.common.white,
    left: '6px',
  },
  thumbnailIconChecked: {
    color: theme.palette.common.white,
  },
  listIconChecked: {
    color: theme.palette.primary.main,
  },
}));

function RoundSwitch({ onChange, value }: SwitchProps) {
  const classes = useStyles();

  const onChecked = useCallback(() => {
    onChange(!value);
  }, [value, onChange]);

  return (
    <label className={classes.root}>
      <input type="checkbox" checked={value} onChange={onChecked} />
      <span className={clsx(classes.slider, classes.round, value && classes.sliderChecked)}>
        <span className={clsx(classes.button, value && classes.buttonChecked)}></span>
      </span>
      <CollectionsIcon
        className={clsx(classes.icon, classes.thumbnailIcon, value && classes.thumbnailIconChecked)}
      />
      <ListIcon
        className={clsx(classes.icon, classes.listIcon, value && classes.listIconChecked)}
      />
    </label>
  );
}

export default RoundSwitch;
